import {Controller, useFormContext} from "react-hook-form";
import Input from "../../../../shared/formElements/input";
import React from "react";

export const OTPCodeInput = () => {
    const {
        control,
        formState: { errors },
    } = useFormContext();

    return (
        <>
            <Controller
                render={(props) => (
                    <Input
                        {...props}
                        type="text"
                        label="OTP Code"
                        fieldName="otpCode"
                        width="100%"
                    />
                )}
                name="otpCode"
                control={control}
                defaultValue=""
            />
        </>
    )
}